import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { License } from 'src/app/models/licenses.model';
import { FirestoreService } from 'src/app/services/firestore.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient } from '@angular/common/http';
import { NewAuthService } from '../auth/new-auth-service.service';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  constructor(
    private readonly db: AngularFirestore,
    private readonly http: HttpClient,
    private readonly firestoreService: FirestoreService,
    private readonly auth: NewAuthService
  ) {}

  getAll(): Observable<License[]> {
    const userId = this.auth.user.user_id;
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${userId}/licenses`;
    return this.http.get<License[]>(endpoint);
  }

  getOne(id: string): Observable<License> {
    const userId = this.auth.user.user_id;
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${userId}/licenses/${id}`;
    return this.http.get<License>(endpoint);
  }

  create(license: License): Observable<License> {
    const userId = this.auth.user.user_id;
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${userId}/licenses`;
    return this.http.post<License>(endpoint, license);
  }

  update(id: string, license: License): Observable<License> {
    const userId = this.auth.user.user_id;
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${userId}/licenses/${id}`;
    return this.http.patch<License>(endpoint, license);
  }

  delete(id: string): Observable<License> {
    const userId = this.auth.user.user_id;
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${userId}/licenses/${id}`;
    return this.http.delete<License>(endpoint);
  }

  getProviderLicenses(providerId: string): Observable<License[]> {
    const endpoint = environment.welbyEndpoint + `/api/v1/users/${providerId}/licenses`;
    return this.http.get<License[]>(endpoint).pipe(
      catchError((err) => {
        console.error('Error fetching provider licenses', err);
        return throwError(() => new Error('PROVIDER_LICENSES_FETCH_FAILED'));
      })
    );
  }
}
